import { Loading } from '../Loading';
import { TableRoot, TableRootProps } from './components';
import { TableDataProvider } from './providers';

/**
 * @summary Основной компонент таблицы.
 *
 * @description Имеющийся функционал:
 * 1. Сортировка по столбцу. По умолчанию ни один столбец не доступен для сортировки.
 * 2. Поиск по данным.
 * 3. Пагинация.
 * 4. Отображение формы редактирования вместо строки.
 *
 * @param children - Шаблон для отображения таблицы.
 * @param data - Данные для ячеек.
 * @param id - Идентификатор таблицы. Используется для корректной идентификации настроек, хранимых в LocalStorage.
 * @param uniqueFieldGetter - Геттер для получения значения uniqueField в случаях, когда его нельзя задать напрямую.
 * Это может быть в случаях, когда Data состоит из двух полей, которые хранят объекты, и уникальное поле нужно
 * искать в них.
 * @param match - Функция поиска в данных. Включает возможность поиска.
 * @param compare - Функция для сортировки данных. Включает возможность сортировки.
 * @param isSort - Key - название столбца, value - можно ли сортировать. Включает возможность сортировки конкретного столбца.
 * @param pagination - Значение для включения пагинации.
 * @param tableLayoutFixed - Фиксит размеры ячеек, позволяя переносить текст в ячейках.
 * @param uniqueField - Уникальное поле для строки в таблице. Используется как key при отображении. Должен быть уникальным на весь столбец данных.
 * @param isLoading - Включает элемент загрузки вместо отображения данных.
 * @param onChangeSort - Срабатывает на изменения сортировки.
 * @param onChangeSearch - Срабатывает на изнения значения поиска и его включение.
 * @param create - Включает отображение кнопки для перехода в форму добавления значения.
 */
export const TableMUI = <Data extends unknown>(props: TableRootProps<Data>) => (
  <TableDataProvider tableData={props.data} tableId={props.id ?? ''}>
    {props.data === undefined ? <Loading /> : <TableRoot<Data> {...props} />}
  </TableDataProvider>
);
